<template>
  <div class="popup">
    <div class="popup__head">
      <span class='questions__bill' v-if="form.number" v-html="getNumberQuestion"></span>
      <span class='questions__bill' v-if="this.form.type === 'text_block'">!</span>
      <span>{{ getQuestionTypes[form.type] }}</span>
      <span class="sync_btn"
            v-tooltip="this.getModalData.id && !this.getModalData.poll_id ? 'Sync all questons' : 'Sync current question'"
            v-if="this.getModalData.number"
            @click="sincQuestion">
        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 480.011 480.011" height="26" viewBox="0 0 480.011 480.011" width="26">
          <g>
            <path d="m440.03 216.004c-14.362-.012-26.964-9.572-30.844-23.4-10.301-36.573-32.069-68.873-62.1-92.15-63.11-48.595-151.033-48.595-214.143 0-12.083 9.329-22.896 20.195-32.164 32.325l66.2-19.471c16.955-4.987 34.742 4.716 39.729 21.671s-4.716 34.742-21.671 39.729l-135.994 40c-16.955 4.986-34.742-4.717-39.728-21.672-.694-2.362-1.114-4.795-1.251-7.253l-8-144c-1.104-17.639 12.301-32.832 29.939-33.935s32.832 12.301 33.935 29.94c.009.149.018.298.025.448l2.045 36.805c84.413-89.396 222.822-100.304 320.196-25.237 40.928 31.727 70.593 75.753 84.629 125.6 4.75 17.023-5.2 34.673-22.223 39.423-2.793.779-5.678 1.175-8.577 1.177zm-408.017-192c-.3 0-.593.009-.893.025-8.816.503-15.562 8.046-15.082 16.863l8 144c.491 8.823 8.041 15.577 16.864 15.087 1.228-.068 2.443-.278 3.623-.625l136-40c8.478-2.493 13.329-11.387 10.835-19.865s-11.387-13.329-19.865-10.835l-87.453 25.722c-4.239 1.247-8.686-1.179-9.932-5.418-.624-2.123-.342-4.409.781-6.316 12.433-21.203 28.818-39.824 48.268-54.853l4.89 6.331-4.89-6.331c68.87-53.045 164.83-53.045 233.7 0 32.758 25.389 56.502 60.622 67.738 100.515 2.375 8.512 11.2 13.487 19.712 11.112s13.487-11.2 11.112-19.712c-13.103-46.531-40.794-87.627-79-117.243-80.393-61.945-192.431-61.945-272.824 0-14.208 10.994-27.043 23.658-38.227 37.717-2.753 3.456-7.786 4.026-11.242 1.273-1.784-1.421-2.877-3.536-3.003-5.814l-3.14-56.523c-.484-8.471-7.488-15.096-15.972-15.11z"/>
            <path d="m240.013 480.004c-52.923.184-104.385-17.344-146.193-49.793-40.928-31.726-70.592-75.751-84.627-125.597-4.689-17.04 5.323-34.654 22.363-39.343 16.957-4.666 34.501 5.226 39.284 22.15 10.301 36.571 32.069 68.869 62.1 92.143 76.608 59.134 186.648 44.969 245.782-31.639.176-.228.351-.456.526-.685l-66.2 19.471c-16.882 5.23-34.806-4.216-40.036-21.098s4.216-34.806 21.098-40.036c.292-.091.586-.177.881-.259l135.993-40c16.955-4.986 34.742 4.716 39.728 21.672.694 2.361 1.114 4.794 1.251 7.25l8 143.989c.959 17.637-12.54 32.723-30.175 33.722-.6.034-1.2.051-1.8.051-16.975-.012-30.986-13.276-31.928-30.225l-2.045-36.8c-45.149 47.968-108.129 75.124-174.002 75.027zm-200.008-199.985c-8.837.006-15.995 7.175-15.989 16.011.001 1.45.199 2.892.589 4.289 13.103 46.528 40.794 87.622 79 117.235 80.395 61.94 192.43 61.94 272.825 0 14.208-10.994 27.042-23.656 38.227-37.714 2.753-3.456 7.786-4.026 11.242-1.273 1.784 1.421 2.876 3.536 3.003 5.813l3.14 56.518c.547 8.82 8.141 15.526 16.96 14.978 8.739-.542 15.419-8.009 14.99-16.754l-8-143.988c-.491-8.823-8.042-15.577-16.865-15.086-1.228.068-2.444.278-3.623.625l-135.995 40c-8.483 2.476-13.352 11.359-10.876 19.842s11.359 13.352 19.842 10.876c.021-.006.041-.012.062-.018l87.449-25.719c4.239-1.247 8.686 1.178 9.933 5.416.625 2.123.342 4.411-.781 6.318-12.433 21.202-28.818 39.821-48.268 54.848-68.871 53.043-164.829 53.043-233.7 0-32.755-25.385-56.498-60.613-67.735-100.5-1.936-6.923-8.242-11.712-15.43-11.717z"/>
          </g>
        </svg>
      </span>
    </div>
    <div class="popup__body">
      <div class="popup__carry d-inline-flex">
        <div class="popup__tab" :class="{active: tab === 1}" @click="tab = 1">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.90625 4.41406C3.90625 3.98254 4.25598 3.63281 4.6875 3.63281H15.3125C15.744 3.63281 16.0938 3.98254 16.0938 4.41406C16.0938 4.84558 15.744 5.19531 15.3125 5.19531H4.6875C4.25598 5.19531 3.90625 4.84558 3.90625 4.41406ZM16.0938 7.53906C16.0938 7.10754 15.744 6.75781 15.3125 6.75781H4.6875C4.25598 6.75781 3.90625 7.10754 3.90625 7.53906C3.90625 7.97058 4.25598 8.32031 4.6875 8.32031H15.3125C15.744 8.32031 16.0938 7.97058 16.0938 7.53906ZM4.6875 9.88281C4.25598 9.88281 3.90625 10.2325 3.90625 10.6641C3.90625 11.0956 4.25598 11.4453 4.6875 11.4453H8.28125C8.71277 11.4453 9.0625 11.0956 9.0625 10.6641C9.0625 10.2325 8.71277 9.88281 8.28125 9.88281H4.6875ZM19.3141 15.9996C20.2274 16.9128 20.2274 18.3997 19.3135 19.3135C18.8567 19.7704 18.2564 19.9989 17.6562 19.9989C17.0561 19.9989 16.4558 19.7704 15.999 19.3135L11.7268 15.0334C11.6316 14.938 11.5628 14.8198 11.5269 14.6899L10.6534 11.5367C10.5774 11.2621 10.6567 10.9679 10.8607 10.7689C11.0646 10.5701 11.3606 10.4977 11.6333 10.5806L14.7086 11.5147C14.8317 11.5521 14.9437 11.6193 15.0345 11.7104L19.3141 15.9996ZM12.9778 14.0749L15.8495 16.9519L16.9545 15.8469L14.0668 12.9527L12.5383 12.4884L12.9778 14.0749ZM18.2086 17.1039L18.0582 16.953L16.9533 18.0579L17.1043 18.2092C17.4084 18.5133 17.9041 18.5133 18.2086 18.2086C18.5133 17.9041 18.5133 17.4084 18.2086 17.1039ZM16.875 0H3.125C1.40182 0 0 1.40182 0 3.125V16.875C0 18.5982 1.40182 20 3.125 20H12.6953C13.1268 20 13.4766 19.6503 13.4766 19.2188C13.4766 18.7872 13.1268 18.4375 12.6953 18.4375H3.125C2.26349 18.4375 1.5625 17.7365 1.5625 16.875V3.125C1.5625 2.26349 2.26349 1.5625 3.125 1.5625H16.875C17.7365 1.5625 18.4375 2.26349 18.4375 3.125V12.7344C18.4375 13.1659 18.7872 13.5156 19.2188 13.5156C19.6503 13.5156 20 13.1659 20 12.7344V3.125C20 1.40182 18.5982 0 16.875 0Z"
                  fill="#4F4F4F"/>
          </svg>
          Сontent
        </div>
        <div class="popup__tab" v-if="form.type !== 'text_block'" :class="{active: tab === 2}" @click="tab = 2">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.6276 20H9.37238C8.35719 20 7.53121 19.1741 7.53121 18.1589V17.7342C7.09961 17.5963 6.68027 17.4223 6.27742 17.2138L5.97648 17.5147C5.24762 18.2445 4.08008 18.2231 3.37238 17.5145L2.48523 16.6273C1.77629 15.9192 1.7559 14.752 2.48547 14.0232L2.78617 13.7225C2.5777 13.3197 2.40367 12.9004 2.26574 12.4688H1.84113C0.825976 12.4688 0 11.6428 0 10.6276V9.37238C0 8.35719 0.825976 7.53125 1.84117 7.53125H2.26578C2.40371 7.09961 2.57773 6.68031 2.78621 6.27746L2.48527 5.97656C1.75613 5.2482 1.77625 4.08094 2.48551 3.37246L3.37273 2.48527C4.08207 1.77496 5.24934 1.75723 5.9768 2.48551L6.27746 2.78617C6.68031 2.57773 7.09965 2.40367 7.53125 2.26574V1.84113C7.53125 0.825937 8.35719 0 9.37242 0H10.6276C11.6428 0 12.4688 0.825937 12.4688 1.84113V2.26578C12.9004 2.40367 13.3197 2.57773 13.7225 2.78621L14.0235 2.48527C14.7523 1.75551 15.9199 1.77691 16.6276 2.48555L17.5147 3.37266C18.2237 4.08082 18.2441 5.24797 17.5145 5.97676L17.2138 6.27746C17.4223 6.68031 17.5963 7.09957 17.7342 7.53125H18.1588C19.174 7.53125 20 8.35719 20 9.37238V10.6276C20 11.6428 19.174 12.4688 18.1588 12.4688H17.7342C17.5963 12.9004 17.4223 13.3197 17.2138 13.7225L17.5147 14.0235C18.2439 14.7518 18.2237 15.9191 17.5145 16.6276L16.6273 17.5148C15.9179 18.2251 14.7507 18.2428 14.0232 17.5145L13.7225 17.2139C13.3197 17.4223 12.9004 17.5964 12.4688 17.7343V18.1589C12.4688 19.1741 11.6428 20 10.6276 20ZM6.47332 15.9832C7.03297 16.3142 7.63531 16.5642 8.26359 16.7264C8.52234 16.7931 8.70312 17.0265 8.70312 17.2937V18.1589C8.70312 18.5279 9.0034 18.8281 9.37242 18.8281H10.6276C10.9966 18.8281 11.2969 18.5279 11.2969 18.1589V17.2937C11.2969 17.0265 11.4777 16.7931 11.7364 16.7264C12.3647 16.5642 12.9671 16.3142 13.5267 15.9832C13.757 15.847 14.0502 15.8841 14.2393 16.0732L14.8521 16.6861C15.1164 16.9506 15.5407 16.9445 15.7984 16.6864L16.6862 15.7986C16.9433 15.5418 16.9519 15.1175 16.6864 14.8523L16.0733 14.2393C15.8842 14.0501 15.8471 13.7569 15.9833 13.5267C16.3143 12.9671 16.5643 12.3647 16.7264 11.7364C16.7932 11.4777 17.0266 11.2969 17.2938 11.2969H18.1589C18.5279 11.2969 18.8282 10.9967 18.8282 10.6277V9.37242C18.8282 9.0034 18.5279 8.70316 18.1589 8.70316H17.2938C17.0265 8.70316 16.7932 8.52238 16.7264 8.26367C16.5643 7.63535 16.3142 7.03301 15.9833 6.4734C15.8471 6.24316 15.8842 5.94996 16.0733 5.76082L16.6862 5.14797C16.9511 4.88336 16.9442 4.45914 16.6864 4.20168L15.7987 3.31398C15.5414 3.05633 15.117 3.04879 14.8524 3.31375L14.2394 3.92684C14.0502 4.11602 13.757 4.15305 13.5268 4.01688C12.9671 3.6859 12.3648 3.43586 11.7365 3.27371C11.4777 3.20695 11.297 2.97359 11.297 2.70637V1.84113C11.297 1.47211 10.9967 1.17188 10.6277 1.17188H9.37246C9.00344 1.17188 8.70316 1.47211 8.70316 1.84113V2.70629C8.70316 2.97352 8.52238 3.20688 8.26363 3.27363C7.63535 3.43578 7.03301 3.68582 6.47336 4.0168C6.24305 4.15293 5.94988 4.1159 5.76074 3.92676L5.14793 3.31391C4.88371 3.04938 4.45938 3.05551 4.20168 3.31363L3.31391 4.20137C3.0568 4.45816 3.0482 4.8825 3.31367 5.14766L3.92676 5.76074C4.1159 5.94988 4.15293 6.24309 4.0168 6.47332C3.68582 7.03293 3.43582 7.63527 3.27367 8.26359C3.20688 8.52234 2.97352 8.70309 2.70633 8.70309H1.84117C1.47215 8.70312 1.17188 9.00336 1.17188 9.37238V10.6276C1.17188 10.9966 1.47215 11.2969 1.84117 11.2969H2.70629C2.97352 11.2969 3.20684 11.4777 3.27363 11.7364C3.43578 12.3647 3.68582 12.967 4.01676 13.5266C4.15289 13.7569 4.11586 14.0501 3.92672 14.2392L3.31387 14.8521C3.04895 15.1167 3.05586 15.5409 3.31363 15.7984L4.20133 16.6861C4.45863 16.9437 4.88301 16.9513 5.14762 16.6863L5.76066 16.0732C5.90004 15.9339 6.19 15.8156 6.47332 15.9832Z"
                  fill="#4F4F4F"/>
            <path d="M10 14.3516C7.60051 14.3516 5.64844 12.3995 5.64844 10C5.64844 7.60055 7.60051 5.64844 10 5.64844C12.3995 5.64844 14.3516 7.60055 14.3516 10C14.3516 12.3995 12.3995 14.3516 10 14.3516ZM10 6.82031C8.24668 6.82031 6.82031 8.24672 6.82031 10C6.82031 11.7533 8.24672 13.1797 10 13.1797C11.7533 13.1797 13.1797 11.7533 13.1797 10C13.1797 8.24672 11.7533 6.82031 10 6.82031Z"
                  fill="#4F4F4F"/>
            <defs>
              <clipPath id="clip0">
                <rect width="20" height="20" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          Settings
        </div>
        <div class="popup__tab" :class="{active: tab === 3}" @click="tab = 3">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.7273 13.6373C17.1575 13.6373 16.6423 13.8554 16.243 14.2031L13.1291 11.8218C13.4432 11.2842 13.6364 10.6673 13.6364 10.001C13.6364 9.36081 13.4558 8.76767 13.1641 8.24463L15.2988 6.67892C15.7023 7.04459 16.2321 7.27368 16.8182 7.27368C18.0713 7.27368 19.0909 6.25406 19.0909 5.00097C19.0909 3.74787 18.0713 2.72821 16.8182 2.72821C15.5651 2.72821 14.5455 3.74783 14.5455 5.00092C14.5455 5.33962 14.625 5.65832 14.7584 5.94737L12.6327 7.50661C11.9695 6.80697 11.0378 6.3646 10 6.3646C9.71033 6.3646 9.43211 6.40739 9.16185 6.47169L8.63834 5.07516C9.44851 4.6018 10 3.7324 10 2.72825C10 1.22433 8.77667 0.000976562 7.27275 0.000976562C5.76883 0.000976562 4.54547 1.22433 4.54547 2.72825C4.54547 4.23217 5.76883 5.45553 7.27275 5.45553C7.45002 5.45553 7.62248 5.43567 7.79042 5.4032L8.31359 6.79884C7.34877 7.30943 6.63699 8.22908 6.43091 9.33567L4.5127 9.22308C4.35401 8.12391 3.41514 7.27368 2.27271 7.27368C1.01962 7.27368 0 8.2933 0 9.54639C0 10.7995 1.01962 11.8191 2.27271 11.8191C3.32267 11.8191 4.20009 11.0996 4.45978 10.1304L6.38817 10.2436C6.45064 11.1689 6.84797 12.0012 7.47606 12.609L5.78804 14.8598C5.41368 14.6662 4.9953 14.5463 4.54547 14.5463C3.04155 14.5463 1.8182 15.7697 1.8182 17.2736C1.8182 18.7775 3.04155 20.0009 4.54547 20.0009C6.04939 20.0009 7.27275 18.7775 7.27275 17.2736C7.27275 16.5471 6.98293 15.8901 6.51831 15.4008L8.2091 13.1463C8.74006 13.4499 9.34586 13.6373 10 13.6373C11.0119 13.6373 11.9268 13.2202 12.5866 12.551L15.6892 14.9236C15.5435 15.2232 15.4546 15.5551 15.4546 15.91C15.4546 17.1631 16.4742 18.1827 17.7273 18.1827C18.9804 18.1827 20 17.1631 20 15.91C20 14.6569 18.9804 13.6373 17.7273 13.6373ZM16.8182 3.63729C17.5702 3.63729 18.1818 4.24896 18.1818 5.00092C18.1818 5.75288 17.5702 6.36456 16.8182 6.36456C16.0662 6.36456 15.4546 5.75288 15.4546 5.00092C15.4546 4.24896 16.0662 3.63729 16.8182 3.63729ZM2.27271 10.91C1.52075 10.91 0.909077 10.2984 0.909077 9.54639C0.909077 8.79443 1.52075 8.18276 2.27271 8.18276C3.02468 8.18276 3.63635 8.79443 3.63635 9.54639C3.63635 10.2984 3.02468 10.91 2.27271 10.91ZM4.54547 19.0919C3.54269 19.0919 2.72727 18.2764 2.72727 17.2737C2.72727 16.2709 3.54269 15.4555 4.54547 15.4555C5.54826 15.4555 6.36367 16.2709 6.36367 17.2737C6.36367 18.2764 5.54821 19.0919 4.54547 19.0919ZM7.27275 4.54641C6.26996 4.54641 5.45455 3.73095 5.45455 2.72821C5.45455 1.72547 6.26996 0.910011 7.27275 0.910011C8.27553 0.910011 9.0909 1.72547 9.0909 2.72821C9.0909 3.73095 8.27549 4.54641 7.27275 4.54641ZM10 12.7282C8.4961 12.7282 7.27275 11.5049 7.27275 10.001C7.27275 8.49703 8.4961 7.27368 10 7.27368C11.5039 7.27368 12.7273 8.49703 12.7273 10.001C12.7273 11.5049 11.5039 12.7282 10 12.7282ZM17.7273 17.2737C16.9753 17.2737 16.3636 16.662 16.3636 15.91C16.3636 15.1581 16.9753 14.5464 17.7273 14.5464C18.4792 14.5464 19.0909 15.1581 19.0909 15.91C19.0909 16.662 18.4792 17.2737 17.7273 17.2737Z"
                  fill="#333333"/>
            <defs>
              <clipPath id="clip0">
                <rect width="20" height="20" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          Logic Function
        </div>
      </div>
      <div class="popup__toggle float-right" v-if="form.type !== 'text_block'">
        <label class="stud m-0 mb-1 d-block w-100">
          <input type="checkbox" v-model="form.attach_comment">
          <div class="stud__text">Comment</div>
        </label>
        <label class="stud m-0 d-block w-100">
          <input type="checkbox" v-model="form.attach_photo"/>
          <div class="stud__text">Photo</div>
        </label>
      </div>
      <div id="1" class="popup__mass" :class="{active: tab === 1}">
        <!-- <v-slick ref="slick" class="popup__typesetting" :options="slickOptions">
          <div class="popup__language" v-for="item of getLangOptions" :class="{active: item.value == lang}" @click="lang = item.value">
            <img :src="'/img/lang/' + item.value + '.png'" :alt="item.label" class="popup__pennant"/>
            <div class="popup__language-name">{{ item.label }}</div>
          </div>
        </v-slick> -->

        <div class="popup__question">
          <div class="popup__topic">Survey Language</div>
            <v-select :options="getLangOptions" :flags="true" :value="lang" :search="true" @input="onChangeLang($event)"/>
          </div>

        
        <div class="popup__question" v-if="!this.getModalData.poll_id && !this.getModalData.is_draft">
          <div class="popup__topic">question number</div>
          <div class="answers__item">
            <div class="answers__name w-100">
              <input v-model="form.number" placeholder="Type here..." class="popup__text border-0 w-100">
            </div>
          </div>
        </div>
        <div class="popup__question">
          <div class="popup__topic">question text</div>
          <textarea v-model="form.text[lang]" placeholder="Type here..." class="popup__textarea"></textarea>
        </div>
        <div class="popup__question" v-if="getModalData.poll_id && form.type == 'concentration'">
          <div class="popup__topic">Go to the question before answering "Don't know"</div>
          <vue-select v-model="form.goto"
                      :options="goToQuestions"/>
        </div>
        <div v-if="['single', 'multiple', 'sort'].includes(form.type)" class="popup__answers">
          <div class="popup__topic" v-if="getModalData.number && !this.getModalData.is_draft && !getModalData.poll_id">
            Add Possible Answer's or <a href="" @click.prevent="modal_dictionary = true">link to a Reference</a>
            <template v-if="this.getModalData.poll_id || this.getModalData.is_draft">
              or <a href="" @click.prevent="modal_previously = true">previously selected options</a>
            </template>
          </div>
          <div class="text-muted mb-2" v-if="form.answers_dictionary.type">
            <small>
              Selected dictionary: <b>{{ form.answers_dictionary.type == 'scopes' ? 'crops' : form.answers_dictionary.type }}</b>
            </small>
            <small v-if="form.answers_dictionary.countries_id">
              ({{ getCountriesName(form.answers_dictionary.countries_id).join(', ') }})
            </small>
          </div>
          <div class="text-muted mb-2" v-if="modalPreviouslyQuestionText">
            <small>
              Answer options include the answers from the question: <b>{{ modalPreviouslyQuestionText }}</b>
            </small>
          </div>
          <div class="answers" v-if="!form.use_question_id && !form.answers_dictionary.type">
            <v-draggable v-model="sort" handle=".handle" @sort="onSort($event)">
              <div class="drag_item" v-for="(answer, index) of form.answers" :index="index" :key="answer.id">
                <div class="answers__set">
                  <div class="answers__box">
                    <div class="answers__force handle"></div>
                    <div class="answers__item">
                      <div class="answers__name w-100">
                        <input type="text" class="popup__text border-0 w-100" v-model="form.answers[index].text[lang]" placeholder="Possible answer...">
                      </div>
                      <div class="answers__file" v-if="form.image_answers && !form.answers[index].image">
                        <label class="answers__file-label">
                          <input type="file" @change="onChangeFile($event, index)" class="answers__file-field"/>
                          <img class="answers__file-img"/>
                        </label>
                      </div>
                    </div>
                    <div class="answers__item answers__weight" v-if="form.view_conditions.organsystems.length">
                      <div class="answers__name w-100">
                        <input type="text" class="popup__text border-0 w-100" v-model="form.answers[index].weight" placeholder="weight">
                      </div>
                    </div>
                    <div class="answers__del" @click="onDelAnswer(index, answer)"></div>
                  </div>
                  <div class="d-inline-block position-relative" v-if="form.image_answers && form.answers[index].image">
                    <span class="image__del" @click="form.answers[index].image = null">&times;</span>
                    <img v-if="form.image_answers" class="img-thumbnail mb-2" :src="form.answers[index].image" style="height: 150px"/>
                  </div>
                </div>
              </div>
            </v-draggable>
            <template v-if="!form.use_question_id">
              <div class="answers__add" @click="onAddAnswer">Add an answer</div>
            </template>
          </div>
        </div>
        <div v-if="form.use_question_id && form.answers_dictionary.type == null" class="popup__answers">
          <div class="popup__topic">Possible answers</div>
          <div class="questions__checkbox" v-for="answer of answersOptions">
            <label class="checkbox">
              <input type="checkbox" v-model="form.use_answers_id" :value="answer.id"/>
              <span class="checkbox__part">
                <span class="checkbox__text">{{ answer.text }}</span>
              </span>
            </label>
          </div>
        </div>
      </div>
      <div id="2" class="popup__mass" v-if="form.type !== 'text_block'" :class="{active: tab === 2}">
        <div class="popup__suits">
          <div class="position-relative" v-for="(type, index) in questionTypeOptions" style="height: 35px;">
            <input :id="'type' + index" v-model="form.type" type="radio" :value="type.id" class="test__radio"/>
            <label :for="'type' + index" class="test__label">
              {{ type.text }}
              <div class="answers__item ml-5 p-0" v-if="type.id === 'multiple' && form.type === 'multiple'" style="width: 100px; height: 25px">
                <div class="answers__name w-100 pr-0">
                  <input type="text" placeholder="quantity" class="popup__text text-center border-0 w-100" v-model="form.answers_quantity">
                </div>
              </div>
            </label>
          </div>

          <div class="popup__checkbox mt-2 pl-1">
            <label class="checkbox">
              <input type="checkbox" v-model="form.show_body_map"/><span class="checkbox__part"><span class="checkbox__text">Show body map after question</span></span>
            </label>
          </div>
        </div>
      </div>
      <div id="3" class="popup__mass" :class="{active: tab === 3}">
        <div class="popup__suits">
          <label class="questions__topic mb-0">Organs systems</label>
          <div class="questions__square">
            <vue-select v-model="form.view_conditions.organsystems"
                        :options="organsystems"
                        :settings="{ multiple: true }"/>
          </div>
        </div>

        <!--Question view_conditions-->
        <template v-if="previousQuestions.length">
          <div class="popup__suits">
            <label class="questions__topic mb-0">Previous question</label>
            <div class="questions__square">
              <vue-select v-model="form.view_conditions.previous_question"
                          :options="previousQuestions"/>
            </div>
          </div>
          <div class="popup__suits" v-if="form.view_conditions.previous_question">
            <label class="mb-0 font-weight-bold h6">Select answer(s)</label>
            <div class="questions__square">
              <vue-select v-model="form.view_conditions.previous_question_answers"
                          :options="previousQuestionsAnswers"
                          :settings="{ multiple: true }"/>
            </div>
          </div>
        </template>

        <template v-if="['single', 'multiple'].includes(form.type) && answersOptions.length">
          <div class="popup__suits">
            <label class="questions__topic mb-0">Stop answers</label>
            <div class="questions__square">
              <vue-select v-model="form.stop_answers"
                          :options="answersOptions"
                          :settings="{ multiple: true }"/>
            </div>
          </div>
        </template>
      </div>
      <div class="popup__cellar">
        <button class="popup__submit" @click="onSubmit" :disabled="!form.text['en'] || !form.text['en'].length">Submit</button>
        <button class="popup__cancel" @click="closeModal(true)">Cancel</button>
      </div>
    </div>
    <transition name="fade">
      <div v-if="modal_dictionary || modal_previously" id="sub-modal" class="popup__wrapper popup__add-user popup__add d-flex" @mousedown="closeSubModal($event)">
        <div class="popup">
          <div class="popup__head"><span class='questions__bill'>1</span> {{ modal_dictionary ? 'Select dictionary' : 'Select question' }}</div>
          <div class="popup__body">
            <template v-if="modal_dictionary">
              <div class="popup__suits">
                <label class="questions__topic mb-0">Select Dictionary</label>
                <div class="questions__square">
                  <vue-select v-model="form.answers_dictionary.type" :options="modal_dictionary_options"/>
                </div>
              </div>
              <div class="popup__suits" v-if="(this.getModalData.poll_id || this.getModalData.is_draft) && form.answers_dictionary.type === 'pesticides'">
                <label class="questions__topic mb-0">Select Regions</label>
                <div class="questions__square">
                  <vue-select v-model="form.answers_dictionary.countries_id" :options="getCountriesOptions()" :settings="{multiple: true}"/>
                </div>
              </div>
              <div class="popup__suits" v-if="(this.getModalData.poll_id || this.getModalData.is_draft) && form.answers_dictionary.type === 'substances'">
                <label class="questions__topic mb-0">Select Pesticides</label>
                <div class="questions__square">
                  <vue-select v-model="form.answers_dictionary.pesticides_id" :options="getPesticidesOptionsList" :settings="{multiple: true}"/>
                </div>
              </div>
            </template>
            <template v-if="modal_previously && this.getModalData.poll_id && previousMultipleQuestions.length > 1">
              <div class="popup__suits">
                <label class="questions__topic mb-0">Selected answers from a question</label>
                <div class="questions__square">
                  <vue-select v-model="form.answers_previous_question" :options="previousMultipleQuestions"/>
                </div>
              </div>
            </template>
            <div class="popup__cellar">
              <button class="popup__submit" @click="closeSubModal(true)">Ok</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import _ from 'lodash'

  export default {
    name: 'ModalSurveyQuestion',
    data() {
      return {
        lang: 'en',
        tab: 1,
        modal_dictionary: false,
        modal_previously: false,
        modal_dictionary_options: [
          {id: '0', text: 'None'},
          {id: 'pesticides', text: 'Pesticides'},
          {id: 'active ingredients', text: 'Active Ingredients'},
          {id: 'scopes', text: 'Crops'},
          {id: 'pests', text: 'Pests'},
        ],
        form: {
          id: null,
          number: null,
          poll_id: null,
          parent_id: null,
          text: {},
          type: 'single',
          answers_quantity: null,
          stop_answers: [],
          image_answers: false,
          attach_photo: false,
          attach_comment: false,
          use_question_id: null,
          use_answers_id: null,
          view_conditions: {
            organsystems: [],
            previous_question: null,
            previous_question_answers: [],
          },
          answers: [],
          answers_previous_question: null,
          answers_dictionary: {
            type: null,
            countries_id: [],
            pesticides_id: [],
          },
          show_body_map: false,
          goto: 0,
        },
        slickOptions: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: false,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            },
          ]
        },
        sort: [],
      }
    },
    computed: {
      ...mapGetters([
        'getQuestionTypes',
        'getModalData',
        'getLangOptions',
        'getOrgansystemsOptions',
        'getQuestions',
        'getQuestionAnswers',
        'getSurveyForm',
        'getCountriesOptions',
        'getPesticidesOptions',
        'getCountriesName',
        'getSurveyForm',
      ]),
      getPesticidesOptionsList() {
        let items = this.getPesticidesOptions();
        return _.map(items, p => {
          return {
            id: p.id,
            text: p.text['en']
          }
        })
      },
      questionTypeOptions() {
        let arr = []
        for (let type in this.getQuestionTypes)
          arr.push({id: type, text: this.getQuestionTypes[type]})
        return arr
      },
      organsystems() {
        let arr = []
        for (let item of this.getOrgansystemsOptions.slice(1))
          arr.push({id: item.id, text: item.name.en})
        return arr
      },
      answersOptions() {
        let answers = []
        if (this.getQuestionAnswers)
          for (let answer of this.getQuestionAnswers)
            answers.push({id: answer.id, text: answer.text[this.lang]})
        return answers
      },
      previousQuestions() {
        let array = []
        if (this.getModalData.poll_id) {
          for (let question of this.getSurveyForm.questions) {
            if (!this.getModalData.id || this.getModalData.id !== question.id)
              if (['single', 'multiple'].includes(question.type))
                array.push({id: question.id, text: question.number ? question.number + ' ' + question.text[this.lang] : question.text[this.lang]})
            if (question.childrens)
              for (let sub_question of question.childrens)
                if (['single', 'multiple'].includes(sub_question.type) && this.getModalData.id != sub_question.id)
                  array.push({id: sub_question.id, text: sub_question.number ? sub_question.number + ' ' + sub_question.text[this.lang] : sub_question.text[this.lang]})
          }
        } else if (this.form.parent_id) {
          for (let question of this.getQuestions)
            if (question.id == this.form.parent_id && question.childrens.length) {
              for (let sub_question of question.childrens) {
                if (sub_question.id != this.getModalData.id)
                  array.push({id: sub_question.id, text: sub_question.number + ' ' + sub_question.text[this.lang]})
                if (sub_question.id == this.getModalData.id)
                  break
              }
              break
            }
        }
        if (array.length)
          array.unshift({id: 0, text: 'None'})
        return array
      },
      previousQuestionsAnswers() {
        let array = []
        if (this.getModalData.poll_id) {
          for (let question of this.getSurveyForm.questions)
            if (this.form.view_conditions.previous_question == question.id)
              for (let answer of question.answers)
                array.push({id: answer.id, text: answer.text[this.lang]})

          if (!array.length) {
            for (let question of this.getSurveyForm.questions) {
              for (let sub_question of question.childrens)
                if (this.form.view_conditions.previous_question == sub_question.id)
                  for (let answer of sub_question.answers)
                    array.push({id: answer.id, text: answer.text[this.lang]})
            }
          }
        } else if (this.form.parent_id) {
          for (let question of this.getQuestions)
            if (question.id == this.form.parent_id && question.childrens.length) {
              for (let sub_question of question.childrens) {
                if (this.form.view_conditions.previous_question == sub_question.id)
                  for (let answer of sub_question.answers)
                    array.push({id: answer.id, text: answer.text[this.lang]})
                if (sub_question.id == this.getModalData.id)
                  break
              }
              break
            }
        }

        return array
      },
      previousMultipleQuestions() {
        let array = []
        array.push({id: 0, text: 'None'})
        for (let question of this.getSurveyForm.questions)
          if (!this.getModalData.id || this.getModalData.id !== question.id)
            if (question.type === 'multiple')
              array.push({id: question.id, text: question.text[this.lang]})
        return array
      },
      modalPreviouslyQuestionText() {
        if (parseInt(this.form.answers_previous_question)) {
          for (let question of this.previousMultipleQuestions)
            if (question.id == this.form.answers_previous_question)
              return question.text
        }
        return ''
      },
      getNumberQuestion() {
        if (this.form.number && this.form.number.length > 3)
          return '<small>' + this.form.number + '</small>'
        return this.form.number
      },
      goToQuestions() {
        let array = []
        let before = false
        if (this.getModalData.poll_id) {
          for (let question of this.getSurveyForm.questions) {
            if (before) {
              let num = question.number ? question.number + ' ' : ''
              array.push({id: question.id, text: num + question.text[this.lang]})
            }

            if (question.sort == this.getModalData.sort)
              before = true
          }
        }
        return array
      }
    },
    watch: {
      'form.answers_dictionary.type'(val) {
        if (val == '0')
          this.form.answers_dictionary.type = null
        // this.form.answers_dictionary.countries_id = []
        // this.form.answers_dictionary.pesticides_id = []
      },
      'form.type'(val) {
        if (!['single', 'multiple'].includes(val))
          this.form.image_answers = false
      },
      'form.view_conditions.previous_question'(val) {
        if (val == 0) {
          this.form.view_conditions.previous_question = null
          this.form.view_conditions.previous_question_answers = []
        }
      },
      'form.show_body_map'(val) {
        if (val) {
          if (this.checkShowBodyMapIsset() !== false) {
            this.$confirm({
              message: 'This option selected in "' + this.checkShowBodyMapIsset() + '" question. Select anyway?',
              callback: confirm => {
                this.form.show_body_map = !!confirm
              }
            })
          }
        }
      }
    },
    mounted() {
      this.queryOrgansystems()
      this.queryPesticides()
      this.queryActiveIngredients()
      this.queryCrops()
      this.queryPests()
      this.queryCountries()

      let self = this
      if (this.getModalData.id) {
        this.form.number = this.getModalData.number
        this.form.text = this.getModalData.text
        this.form.image_answers = this.getModalData.image_answers
        this.form.attach_comment = this.getModalData.attach_comment
        this.form.attach_photo = this.getModalData.attach_photo
        this.form.view_conditions = this.getModalData.view_conditions
        this.form.use_question_id = this.getModalData.use_question_id
        this.form.use_answers_id = this.getModalData.use_answers_id
        this.form.answers_previous_question = this.getModalData.answers_previous_question
        this.form.answers_quantity = this.getModalData.answers_quantity
        this.form.show_body_map = this.getModalData.show_body_map
        this.form.goto = this.getModalData.goto
        if (this.getModalData.answers_dictionary)
          this.form.answers_dictionary = this.getModalData.answers_dictionary
        for (let answer of this.getModalData.answers) {
          self.form.answers.push({
            id: answer.id,
            question_id: answer.question_id,
            text: answer.text,
            sort: answer.sort,
            weight: answer.weight,
            image: answer.image,
          })
        }
        if (this.form.use_question_id)
          this.queryQuestionAnswers(this.form.use_question_id)
        else
          this.queryQuestionAnswers(this.getModalData.id)
      }
      if (this.getModalData.poll_id)
        this.form.poll_id = this.getModalData.poll_id
      if (this.getModalData.parent_id)
        this.form.parent_id = this.getModalData.parent_id
      if (this.getModalData.is_draft)
        this.form.is_draft = this.getModalData.is_draft
      if (this.getModalData.type)
        this.form.type = this.getModalData.type
      if (this.getModalData.sort)
        this.form.sort = this.getModalData.sort
      if (this.getModalData.stop_answers)
        this.form.stop_answers = this.getModalData.stop_answers
    },
    methods: {
      ...mapActions([
        'closeModal',
        'queryPesticides',
        'queryActiveIngredients',
        'queryCrops',
        'queryPests',
        'queryCountries',
        'queryOrgansystems',
        'updateQuestion',
        'deleteAnswer',
        'storeQuestion',
        'queryQuestionAnswers',
        'updateSurveyFormQuestion',
        'syncQuestions',
        'syncCurrentQuestion',
        'querySurvey',
      ]),
      onChangeLang(event) {
        this.lang = event
      },
      onChangeFile(event, index) {
        let self = this
        let reader = new FileReader()
        reader.onload = function () {
          self.form.answers[index].image = reader.result
        }
        reader.readAsDataURL(event.target.files[0])
      },
      onAddAnswer() {
        this.form.answers.push({
          id: null,
          text: {},
          question_id: null,
          sort: 0,
          weight: null,
          image: null
        })
        this.reSort()
      },
      onDelAnswer(index, answer) {
        if (answer.id) {
          this.deleteAnswer(answer)
        }
        this.$delete(this.form.answers, index)
      },
      onSort(event) {
        this.form.answers.splice(event.newIndex, 0, this.form.answers.splice(event.oldIndex, 1)[0])
        this.reSort()
      },
      reSort() {
        for (let i = 0; i < this.form.answers.length; i++)
          this.form.answers[i].sort = i
      },
      onSubmit() {
        if (this.getModalData.id) {
          if (this.form.use_question_id) {
            delete this.form.answers
            this.updateSurveyFormQuestion([this.getModalData.id, this.form])
          } else {
            this.updateQuestion([this.getModalData.id, this.form])
          }
        } else {
          this.storeQuestion(this.form)
        }
      },
      closeSubModal(event) {
        if (event === true || event.target.id === 'sub-modal') {
          this.modal_dictionary = false
          this.modal_previously = false
        }
      },
      checkShowBodyMapIsset() {
        for (let question of this.getSurveyForm.questions) {
          if (question.show_body_map && question.id != this.getModalData.id)
            return question.text[this.lang]
          if (question.childrens)
            for (let subquestion of question.childrens)
              if (subquestion.show_body_map && subquestion.id != this.getModalData.id)
                return subquestion.text[this.lang]
        }
        return false
      },
      sincQuestion() {
        if (this.getModalData.id && !this.getModalData.poll_id) {
          this.syncQuestions(this.getModalData.id)
        } else {
          this.syncCurrentQuestion(this.getModalData.id)
          this.querySurvey(this.getModalData.poll_id)
          this.closeModal(true)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .popup { padding: 25px 40px 75px 40px !important }

  .answers__weight {
    width: 105px;
    margin-left: 20px;
    .answers__name {
      padding: 0;
      input {
        text-align: center;
      }
    }
  }

  .image__del {
    border: 1px solid #0004;
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    background: #fffe;
    border-radius: 50%;
    cursor: pointer;
    line-height: 20px;
    text-align: center;
  }

  .sync_btn {
    cursor: pointer;
    position: absolute;
    display: block;
    right: 0;
  }
</style>